export const FlyingSaucerGreen = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_5432_6434)">
      <rect x="4" y="4" width="40" height="40" rx="20" fill="#F2FBF1" />
      <rect
        x="4.5"
        y="4.5"
        width="39"
        height="39"
        rx="19.5"
        stroke="url(#paint0_linear_5432_6434)"
      />
      <path
        d="M29.8292 22.1292C29.7208 19.0075 27.1483 16.5 24 16.5C20.8517 16.5 18.2792 19.0075 18.1708 22.1292C14.7433 23.2283 14 24.7675 14 25.8933C14 28.615 18.2992 30.6667 24 30.6667C29.7008 30.6667 34 28.615 34 25.8933C34 24.7667 33.2567 23.2283 29.8292 22.1283V22.1292ZM19.8333 22.3333C19.8333 20.0358 21.7025 18.1667 24 18.1667C26.2975 18.1667 28.1667 20.0358 28.1667 22.3333V22.445C27.6783 22.7017 26.4542 23.1667 24 23.1667C21.5317 23.1667 20.3075 22.6967 19.8333 22.4492V22.3333ZM24 29C19.23 29 15.6667 27.36 15.6667 25.8933C15.6667 25.12 16.7908 24.3175 18.7025 23.7083C19.2883 24.1017 20.8075 24.8333 24 24.8333C27.1925 24.8333 28.7117 24.1017 29.2975 23.7083C31.2092 24.3175 32.3333 25.12 32.3333 25.8933C32.3333 27.36 28.77 29 24 29ZM25.25 26.9167C25.25 27.6067 24.69 28.1667 24 28.1667C23.31 28.1667 22.75 27.6067 22.75 26.9167C22.75 26.2267 23.31 25.6667 24 25.6667C24.69 25.6667 25.25 26.2267 25.25 26.9167ZM20.6667 26.0833C20.6667 26.7733 20.1067 27.3333 19.4167 27.3333C18.7267 27.3333 18.1667 26.7733 18.1667 26.0833C18.1667 25.3933 18.7267 24.8333 19.4167 24.8333C20.1067 24.8333 20.6667 25.3933 20.6667 26.0833ZM29.8333 26.0833C29.8333 26.7733 29.2733 27.3333 28.5833 27.3333C27.8933 27.3333 27.3333 26.7733 27.3333 26.0833C27.3333 25.3933 27.8933 24.8333 28.5833 24.8333C29.2733 24.8333 29.8333 25.3933 29.8333 26.0833Z"
        fill="#24843F"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_5432_6434"
        x="0"
        y="0"
        width="48"
        height="48"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="4"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_5432_6434"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.141176 0 0 0 0 0.517647 0 0 0 0 0.247059 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5432_6434"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5432_6434"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_5432_6434"
        x1="24"
        y1="4"
        x2="24"
        y2="44"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A7CEB2" />
        <stop offset="1" stopColor="#A7CEB2" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
